
import BlogsBanner from "../components/Blogs/BlogsBanner";
import BlogsCombine from "../components/Blogs/BlogsCombine";

const BlogPages = () => {

  return (
    <>
      <BlogsBanner />
      <BlogsCombine />
    </>
  );
};

export default BlogPages;
